<template>
	<div>
		<van-nav-bar :title="title"  left-arrow  @click-left="toHome()" >
			<template #left>
			   <img class="header-icon"  src="../../assets/home2.png" />
			</template>
		</van-nav-bar>
	</div>
</template>

<script>
	import { NavBar} from 'vant';
	export default {
	    name:'ComNar',
		components:{
			[NavBar.name]: NavBar,
		},
		props:['title'],
		data(){
			return {
			}
		},
		methods:{
			toHome(){
				this.$router.push("home");
			}
			
		  
		}
	}
</script>


<style scoped>
	.header-icon {
		width: 30px;
		height: 30px;
	}
	[class*=van-hairline]::after {
		border: none;
	}
	.van-nav-bar__content {
		height: 40px;
	}
	.van-nav-bar .van-nav-bar__title {
		font-size:17px;
	}
</style>
